/** 「YYYY-MM」形式の月を扱うヘルパー。カレンダー画面の URL 状態と取得範囲の計算に使う。 */

export function currentMonth(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

export function addMonths(month: string, delta: number): string {
  const [year, monthNumber] = month.split("-").map(Number);
  const date = new Date(year ?? 1970, (monthNumber ?? 1) - 1 + delta, 1);
  return currentMonth(date);
}

/** 月初〜月末の実施日レンジ（両端を含む）。 */
export function monthRange(month: string): { from: string; to: string } {
  const [year, monthNumber] = month.split("-").map(Number);
  const lastDay = new Date(year ?? 1970, monthNumber ?? 1, 0).getDate();
  return { from: `${month}-01`, to: `${month}-${String(lastDay).padStart(2, "0")}` };
}

export function formatMonthLabel(month: string): string {
  const [year, monthNumber] = month.split("-").map(Number);
  return `${year}年${monthNumber}月`;
}

export function toDateString(date: Date): string {
  return `${currentMonth(date)}-${String(date.getDate()).padStart(2, "0")}`;
}
